import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import CashFlowApi from 'api/CashFlowApi';
import { customPortalApi } from 'api/customPortalApi';
import { env } from 'env';
import rootReducer from 'handlers';
import rtkQueryErrorLogger from 'middlewares/requestErrorMiddleware';
import { getAccessToken } from 'utils/getAccessToken';

const API_URL = env.REACT_APP_API_URL;

export const cashFlowApi = new CashFlowApi(getAccessToken, API_URL);

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware().concat(customPortalApi.middleware, rtkQueryErrorLogger),
});

export default store;
